export function isProduction() {
  return process.env.VUE_APP_VLIVE_ENV === 'vlive-prod'
}
